import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '@store/config';

import { PayloadWithCallback, Profile } from '../types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/profile');

export const updateProfile = actionCreator.async<PayloadWithCallback<Profile>, Profile>('PROFILE_UPDATE');
export const updateLocalProfile = actionCreator.async<PayloadWithCallback<Profile>, Profile>('PROFILE_LOCAL');
